"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _console = require("@instructure/console");

/**
 * ---
 * category: utilities
 * ---
 * @param {Boolean} condition a condition that we expect to be true
 * @param {String} context the displayName of the component or Function.name of the utility function
 * @param {String} message a message to display as a console error in DEV env when condition is false
 */
function _default(condition, context, message) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  /*#__PURE__*/

  /*#__PURE__*/
  _console.error.apply(void 0, [condition, "[".concat(context, "] ").concat(message)].concat(args));
}